const color = {
    primaryColor: '#FF473A',
    secondaryColor: 'pink',
    white: '#FFF',
    black: '#000',
    grey: '#333333',
    shaded: '#979797',
    hoverGray: '#ededed'
};

export default color;

